export default __webpack_public_path__ + "static/media/StartGame.47d4335e.mp4";